// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2SAo8","error":"Textarea_error__2hzzD","readonly":"Textarea_readonly__1n97j","disabled":"Textarea_disabled__1crjE"};